import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "./components/ui/sonner";
import ProtectedRoute from "./components/ProtectedRoute";
import LandingPage from "./pages/LandingPage";
import AuthPage from "./pages/AuthPage";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Marketplace from "./pages/Marketplace";
import AgentDetail from "./pages/AgentDetail";
import AgentConsole from "./pages/AgentConsole";
import PricingPage from "./pages/PricingPage";
import SettingsPage from "./pages/SettingsPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import GitHubCallback from "./pages/GitHubCallback";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminAgents from "./pages/admin/AdminAgents";
import AdminPayments from "./pages/admin/AdminPayments";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminRoute from "./components/AdminRoute";
import FounderRoute from "./components/FounderRoute";
import FounderCockpit from "./pages/FounderCockpit";

function AppRouter() {
  const location = useLocation();

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/auth/github/callback" element={<GitHubCallback />} />
      <Route path="/marketplace" element={<Marketplace />} />
      <Route path="/agents/:agentId" element={<AgentDetail />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
      <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
      <Route path="/agents/:agentId/console" element={<ProtectedRoute><AgentConsole /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      {/* Founder Cockpit (owner-only) */}
      <Route path="/founder" element={<FounderRoute><FounderCockpit /></FounderRoute>} />
      {/* Admin Routes */}
      <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
      <Route path="/admin/agents" element={<AdminRoute><AdminAgents /></AdminRoute>} />
      <Route path="/admin/payments" element={<AdminRoute><AdminPayments /></AdminRoute>} />
      <Route path="/admin/settings" element={<AdminRoute><AdminSettings /></AdminRoute>} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster
          theme="dark"
          toastOptions={{
            style: {
              background: '#0a0a0a',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#f0f0f0',
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: '12px',
            },
          }}
        />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
